module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/*global require*/\n\'use strict\';\n\n\nimport "../styles/main.scss";\n\n// import all the json and icons\nfunction importAll (r) {\n  r.keys().forEach(r);\n}\nimportAll(require.context(\'./resources/\', true, /\\.json$/));\nimportAll(require.context(\'../styles/icons/\', true, /\\.svg$/));\nimport \'../images/logo.gif\';\n\n// The original define[]\n\nimport Backbone from \'backbone\';\nimport AppModel from \'models/App\';\nimport AppView from \'views/App\';\nimport $ from \'jquery\';\nimport postal from \'postal\';\nimport XMLLogger from \'logging/XMLLogger\';\n\n\n\nBackbone.history.start();\n\n\nexport {AppModel, AppView, XMLLogger, postal};';

}
return __p
}